import { createContext, useContext, useState } from "react";

const SiteSettingsContext = createContext({});

export const SiteSettingsProvider = ({ children }) => {
  const [settings] = useState(() => window.__SITE_SETTINGS__ || {});
  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
